import { Dispatch } from "redux";
import { RcFile } from "antd/es/upload";
import LocalsService from "../../services/locals-service";
import {
  CREATE_LOCAL_REQUEST,
  CREATE_LOCAL_REQUEST_FAILED,
  CREATE_LOCAL_REQUEST_SUCCESS,
  EDIT_LOCAL_REQUEST,
  EDIT_LOCAL_REQUEST_FAILED,
  EDIT_LOCAL_REQUEST_SUCCESS,
  FETCH_LOCAL_REQUEST,
  FETCH_LOCAL_REQUEST_FAILED,
  FETCH_LOCAL_REQUEST_SUCCESS,
  FETCH_LOCALS_FAILED,
  FETCH_LOCALS_REQUEST,
  REMOVE_LOCAL_REQUEST,
  REMOVE_LOCAL_REQUEST_FAILED,
  REMOVE_LOCAL_REQUEST_SUCCESS,
  SET_LOCAL,
  SET_LOCALS,
} from "../action-types";
import TaskGroupsService from "../../services/taskgroups-service";

export const getLocals = () => (dispatch: Dispatch<any>) => {
  dispatch({
    type: FETCH_LOCALS_REQUEST,
    payload: true,
  });
  return LocalsService.getLocals().then(
    (response) => {
      dispatch({
        type: SET_LOCALS,
        payload: response.data,
      });
      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: FETCH_LOCALS_FAILED,
      });
      return Promise.reject();
    }
  );
};

export const getLocal = (id: string | number) => (dispatch: Dispatch<any>) => {
  dispatch({
    type: FETCH_LOCAL_REQUEST,
    payload: true,
  });
  return LocalsService.getLocal(id).then(
    (response) => {
      dispatch({
        type: FETCH_LOCAL_REQUEST_SUCCESS,
        payload: response.data,
      });
      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: FETCH_LOCAL_REQUEST_FAILED,
      });
      return Promise.reject();
    }
  );
};

export const createLocal = (user: any) => (dispatch: Dispatch<any>) => {
  dispatch({
    type: CREATE_LOCAL_REQUEST,
    payload: true,
  });
  return LocalsService.createLocal(user).then(
    (response) => {
      dispatch({
        type: CREATE_LOCAL_REQUEST_SUCCESS,
        payload: response.data,
      });
      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: CREATE_LOCAL_REQUEST_FAILED,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const editLocal = (id: string | number, data: any) => (
  dispatch: Dispatch<any>
) => {
  dispatch({
    type: EDIT_LOCAL_REQUEST,
    payload: true,
  });
  return LocalsService.editLocal(id, data).then(
    (response) => {
      dispatch({
        type: EDIT_LOCAL_REQUEST_SUCCESS,
        payload: response.data,
      });
      return Promise.resolve(response);
    },
    (error) => {
      dispatch({
        type: EDIT_LOCAL_REQUEST_FAILED,
      });
      return Promise.reject(error);
    }
  );
};

export const setLocal = (user: any) => (dispatch: Dispatch<any>) => {
  return dispatch({
    type: SET_LOCAL,
    payload: true,
  });
};

export const softDeleteLocal = (id: string) => (dispatch: Dispatch<any>) => {
  dispatch({
    type: REMOVE_LOCAL_REQUEST,
    payload: true,
  });

  return LocalsService.softDelete(id).then(
    (response) => {
      dispatch({
        type: REMOVE_LOCAL_REQUEST_SUCCESS,
        payload: id,
      });
      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: REMOVE_LOCAL_REQUEST_FAILED,
        payload: id,
      });

      return Promise.reject(error);
    }
  );
};
